import React, { useCallback, useEffect, useState } from 'react'
import { Box, Icon } from '@ui'
import { clsx } from 'clsx'
import { SECOND_MS } from 'data/constants'
import { Analytics } from 'hooks/useAnalytics'
import { CHANNEL_INFO_PARAMS } from 'routes'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

import { useConnectionStatus } from './hooks/useConnectionStatus'
import * as styles from './ConnectionStatusButton.css'

export const NodeStatusButton = () => {
    const { closePanel, openPanel, isPanelOpen } = usePanelActions()
    const isActive = isPanelOpen(CHANNEL_INFO_PARAMS.NODE_STATUS)

    const onClick = useCallback(() => {
        if (isPanelOpen(CHANNEL_INFO_PARAMS.NODE_STATUS)) {
            closePanel()
        } else {
            openPanel(CHANNEL_INFO_PARAMS.NODE_STATUS)
            Analytics.getInstance().track('clicked river network button')
        }
    }, [closePanel, isPanelOpen, openPanel])

    const { connectionStatus } = useConnectionStatus()
    const [isFlashing, setIsFlashing] = useState(() => connectionStatus === 'syncing')

    useEffect(() => {
        if (connectionStatus === 'syncing') {
            setIsFlashing(true)
        } else {
            const timeout = setTimeout(() => {
                setIsFlashing(false)
            }, SECOND_MS * 3)
            return () => {
                clearTimeout(timeout)
            }
        }
    }, [connectionStatus])

    const statusColor = connectionStatus === 'disconnected' ? '#FFAA29' : '#21E078'

    return (
        <>
            <Box
                hoverable
                centerContent
                cursor="pointer"
                tooltip={isActive ? undefined : 'Towns Network'}
                tooltipOptions={{ placement: 'horizontal' }}
                padding="line"
                background="level2"
                alignSelf="center"
                rounded="sm"
                width="x4"
                height="x4"
                color="gray1"
                onClick={onClick}
            >
                <Icon
                    className={clsx([styles.satelite, { [styles.flashing]: isFlashing }])}
                    style={{ ['--dot-color']: statusColor } as React.CSSProperties}
                    size="square_sm"
                    type={isActive ? 'sateliteFill' : 'satelite'}
                />
            </Box>
        </>
    )
}
